// extracted by mini-css-extract-plugin
export default {"header":"JsonData_header__wiSNP","container":"JsonData_container__FVdrt"};